import { createSelector } from '@reduxjs/toolkit';

import { createAppSelector } from 'wanderu-ducks-utils';

import NAMESPACE from './types';
import { selectAppStateSlice } from '../../selectors';

function selectData(state) {
    return selectAppStateSlice(state)[NAMESPACE];
}

function mapPolicy(policy, code) {
    if (!policy) {
        return undefined;
    }

    return {
        ...policy?.policies,
        code,
    };
}

function mapMultiplePolicies(data, carrierCodes) {
    return carrierCodes?.map((carrierCode) => {
        const policy = data[carrierCode];

        return mapPolicy(policy, carrierCode);
    });
}

const selectPolicies = createAppSelector(
    [
        selectData,
        (_, carrierCodes) => carrierCodes,
    ],
    (data, carrierCodes) => {
        if (!carrierCodes) {
            return undefined;
        }
        if (typeof carrierCodes === 'string') {
            return mapPolicy(data[carrierCodes], carrierCodes);
        }
        return mapMultiplePolicies(data, carrierCodes);
    },
);

const selectAllPolicies = createSelector(
    [selectData],
    (allPolicies) => {
        return Object.entries(allPolicies)
            .reduce((policies, [code, policy]) => ({
                ...policies,
                [code]: mapPolicy(policy, code),
            }), {});
    },
);

export {
    selectAllPolicies,
    selectPolicies,
};
